import { render, staticRenderFns } from "./ClaimFilePicker.vue?vue&type=template&id=7b402ec8&scoped=true"
import script from "./ClaimFilePicker.vue?vue&type=script&lang=js"
export * from "./ClaimFilePicker.vue?vue&type=script&lang=js"
import style0 from "./ClaimFilePicker.vue?vue&type=style&index=0&id=7b402ec8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b402ec8",
  null
  
)

export default component.exports